package horcrux.frontend.common.views.components.input.selectors

import horcrux.common.utils.EnumCompanion
import horcrux.common.utils.StringEnum
import horcrux.frontend.common.State
import horcrux.frontend.common.views.components.input.InfoPopover
import horcrux.frontend.common.views.components.containers.HStack
import mui.material.FormControl
import mui.material.InputLabel
import mui.material.MenuItem
import mui.material.Select
import mui.system.PropsWithSx
import mui.system.sx
import react.FC
import web.cssom.JustifyContent

external interface DropdownSelectorProps<Enum : StringEnum> : PropsWithSx {
    var id: String
    var labelMaybe: String?
    var currentValueState: State<Enum>
    var isDisabledMaybe: ((Enum) -> Boolean)?
    var helpTextMaybe: String?
}

fun <Enum : StringEnum> EnumCompanion<Enum>.dropdownSelector(): FC<DropdownSelectorProps<Enum>> =
    FC { props ->
        val enumByStringValues = this@dropdownSelector.valuesList.associateBy { it.stringValue }
        HStack {
            this.sx {
                this.justifyContent = JustifyContent.center
                +props.sx
            }
            FormControl {
                this.fullWidth = true
                props.labelMaybe?.let { label ->
                    InputLabel {
                        +"$label"
                        this.id = "${props.id}-label"
                    }
                }
                Select {
                    this.id = "${props.id}"
                    this.value = props.currentValueState.get().stringValue
                    this.onChange = { event, _ ->
                        val stringValue = event.target.value
                        val enumValue =
                            enumByStringValues[stringValue] ?: error("$stringValue is unsupported by dropdown menu")
                        props.currentValueState.set(enumValue)
                    }

                    for (value in this@dropdownSelector.valuesList) {
                        MenuItem {
                            +value.stringValue
                            this.value = value.stringValue
                            this.disabled = props.isDisabledMaybe?.invoke(value)
                        }
                    }
                }
            }
            props.helpTextMaybe?.let {
                InfoPopover {
                    this.id = "${props.id}-help"
                    this.text = it
                }
            }
        }
    }
